module.exports = __webpack_public_path__ + "static/media/menu.63562c09.svg";